// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t_cK","questions":"styles_questions__2mLLQ","footer":"styles_footer__dfNrB"};